export const transformArrayWithId = (array, idField = '') =>
  array.map((item, index) => ({
    ...item,
    id: idField ? item[idField] : index,
  }));

const getObjectProp = (obj, prop) =>
  prop.split('.').reduce((r, e) => r[e], obj);

export const transformForSelect = (elements, value, label, levels = {}) => {
  const {
    moreLevels = false,
    levelsValuesKey = '',
    levelsLabelsKey = '',
  } = levels;

  const selectElements = elements.map((element) => ({
    ...element,
    value: moreLevels
      ? getObjectProp(element[value], levelsValuesKey)
      : element[value],
    label: moreLevels
      ? getObjectProp(element[label], levelsLabelsKey)
      : element[label],
  }));

  return selectElements;
};

export const getLabel = (selectedOption) => {
  if (selectedOption.labels && selectedOption.labels.length > 0) {
    const mapLabels = (current) => current.label;
    return selectedOption.labels
      .map(mapLabels)
      .toString()
      .replace(/,/g, '  ');
  }

  return selectedOption.label;
};

export const transformForListStructure = (list, mobileList) => ({
  data: {
    results: {
      list,
      mobileList: mobileList || list,
    },
  },
});
